import RfiInfo from './RfiInfo.component';

export default RfiInfo;
